module.exports = __webpack_public_path__ + "fonts/Barlow-Regular.b15b6ed5.woff";